export const toUpdateNoteSettingsRequestObject = (data) => {
  return {
    noteshrs: data.noteshrs,
    notesmin: data.notesmin,
  };
};

export const toNoteSettingsResponseParser=(data)=>{
    if (data?.status) {
        return {
            noteHours: data?.organizations[0]?.notes_hours,
            noteMinutes: data?.organizations[0]?.notes_minute
        }
    }
}

export const toUpdateNoteSettingsResponseParser=(data)=>{
    return data?.Success
}